// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"79611cd1","26":"1fb2900c","330":"9e20b3a5","335":"93b3f1dd","387":"fd70b2d8","529":"5c3358a0","622":"6d994d2f","671":"4cef17a5","802":"85b6b514","903":"ecf9377d"}[chunkId] + ".chunk.js";
};